import { TransferBaseModel } from '../../transfer-base.model';
import { PayloadPayout } from './payload';

export interface Payout extends TransferBaseModel {
    amount?: number;
    currency?: string;
    status?: string;
    detail?: string;
    ip_address?: string;
    payment_device_id?: string;
    gateway_id?: string;
    created_date?: string;
    updated_date?: string;
    payload?: PayloadPayout;
}
